import React, { type FC } from 'react';
import atlassianIntelligenceIconUrl from 'assets/images/atlassian-intelligence-icon.svg';
import { useIntl } from 'react-intl-next';
import { Box, xcss } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';
import messages from './messages';

export const VirtualAgentBanner: FC = () => {
    const { formatMessage } = useIntl();

    return (
        <Box xcss={containerStyles}>
            <SectionMessage
                title={formatMessage(messages.virtualAgentBannerHeading)}
                icon={() => (
                    <Box xcss={iconStyles}>
                        <img src={atlassianIntelligenceIconUrl} alt={formatMessage(messages.iconAlt)} />
                    </Box>
                )}
            >
                <p>{formatMessage(messages.virtualAgentBannerDescription)}</p>
            </SectionMessage>
        </Box>
    );
};

const containerStyles = xcss({
    marginBottom: token('space.200', '16px'),
});

const iconStyles = xcss({
    alignSelf: 'flex-start',
});
